import { Controller } from "@hotwired/stimulus"

// Copies the value of `data-clipboard-content-value` to the system clipboard
// and briefly swaps the trigger's label to "Copied".
//
//   <div data-controller="clipboard" data-clipboard-content-value="secret">
//     <button data-action="clipboard#copy">Copy</button>
//   </div>
export default class extends Controller {
  static values = { content: String }

  async copy(event) {
    event.preventDefault()
    if (!this.contentValue) return
    try {
      await navigator.clipboard.writeText(this.contentValue)
    } catch (_e) {
      // best-effort fallback for browsers without clipboard permission
      const ta = document.createElement("textarea")
      ta.value = this.contentValue
      document.body.appendChild(ta); ta.select()
      try { document.execCommand("copy") } finally { ta.remove() }
    }

    const btn = event.currentTarget
    const original = btn.textContent
    btn.textContent = "Copied"
    btn.disabled = true
    setTimeout(() => { btn.textContent = original; btn.disabled = false }, 1500)
  }
}
